/**
 *  Language api
 */
import { axios } from '@/utils/request'

const subPath = '/dict/cdb/mealrequest'

export default {
  query,
  list,
  detail,
  add,
  update,
  'delete': remove,
  moveTo
}

// 分页查询
function query (parameter) {
  return axios({
    url: `${subPath}/query`,
    method: 'get',
    params: { ...parameter, 'page.curPage': parameter.curPage, 'page.pageSize': parameter.pageSize }
  })
}

// 列表
function list () {
  return axios({
    url: `${subPath}/list`,
    method: 'get'
  })
}

// 详情
function detail (id) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'get'
  })
}

// 添加
function add (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'post',
    data: parameter
  })
}

// 修改
function update (id, parameter) {
  return axios({
    url: `${subPath}/${id}`,
    method: 'put',
    data: parameter
  })
}

// 删除
function remove (parameter) {
  return axios({
    url: `${subPath}`,
    method: 'delete',
    params: parameter
  })
}

// 列表
function moveTo (id, afterId) {
  if (afterId) {
    return axios({
      url: `${subPath}/${id}/moveTo`,
      method: 'put',
      params: { afterId: afterId}
    })
  } else {
    return axios({
      url: `${subPath}/${id}/moveTo`,
      method: 'put'
    })
  }
}
